var exports = {
  "kL": "x31de4314--6bb331--container",
  "Sl": "x31de4314--6bb331--image",
  "pq": "x31de4314--6bb331--info",
};

module.exports = exports;
